"use strict";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
Object.defineProperty(exports, "__esModule", { value: true });
var coreutils_1 = require("@jupyterlab/coreutils");
var serverconnection_1 = require("../serverconnection");
/**
 * The url for the lab build service.
 */
var BUILD_SETTINGS_URL = 'lab/api/build';
/**
 * The static namespace for `BuildManager`.
 */
var BuildManager = /** @class */ (function () {
    /**
     * Create a new setting manager.
     */
    function BuildManager(options) {
        if (options === void 0) { options = {}; }
        this.serverSettings = options.serverSettings ||
            serverconnection_1.ServerConnection.makeSettings();
    }
    Object.defineProperty(BuildManager.prototype, "isAvailable", {
        /**
         * Test whether the build service is available.
         */
        get: function () {
            return coreutils_1.PageConfig.getOption('buildAvailable').toLowerCase() === 'true';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BuildManager.prototype, "shouldCheck", {
        /**
         * Test whether to check build status automatically.
         */
        get: function () {
            return coreutils_1.PageConfig.getOption('buildCheck').toLowerCase() === 'true';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Get whether the application should be built.
     */
    BuildManager.prototype.getStatus = function () {
        var base = this.serverSettings.baseUrl;
        var url = coreutils_1.URLExt.join(base, BUILD_SETTINGS_URL);
        var serverSettings = this.serverSettings;
        var promise = serverconnection_1.ServerConnection.makeRequest(url, {}, serverSettings);
        return promise.then(function (response) {
            if (response.status !== 200) {
                throw new serverconnection_1.ServerConnection.ResponseError(response);
            }
            return response.json();
        }).then(function (data) {
            if (typeof data.status !== 'string') {
                throw new Error('Invalid data');
            }
            if (typeof data.message !== 'string') {
                throw new Error('Invalid data');
            }
            return data;
        });
    };
    /**
     * Build the application.
     */
    BuildManager.prototype.build = function () {
        var base = this.serverSettings.baseUrl;
        var url = coreutils_1.URLExt.join(base, BUILD_SETTINGS_URL);
        var serverSettings = this.serverSettings;
        var init = { method: 'POST' };
        var promise = serverconnection_1.ServerConnection.makeRequest(url, init, serverSettings);
        return promise.then(function (response) {
            if (response.status === 400) {
                throw new serverconnection_1.ServerConnection.ResponseError(response, 'Build aborted');
            }
            if (response.status !== 200) {
                var message = 'Build failed with ${response.status)`, please run `jupyter lab build` on the server for full output';
                throw new serverconnection_1.ServerConnection.ResponseError(response, message);
            }
        });
    };
    /**
     * Cancel an active build.
     */
    BuildManager.prototype.cancel = function () {
        var base = this.serverSettings.baseUrl;
        var url = coreutils_1.URLExt.join(base, BUILD_SETTINGS_URL);
        var serverSettings = this.serverSettings;
        var init = { method: 'DELETE' };
        var promise = serverconnection_1.ServerConnection.makeRequest(url, init, serverSettings);
        return promise.then(function (response) {
            if (response.status !== 204) {
                throw new serverconnection_1.ServerConnection.ResponseError(response);
            }
        });
    };
    return BuildManager;
}());
exports.BuildManager = BuildManager;
